import { Toaster } from "@safers/ui/molecules";
import { useStompEvents, useAutoPushSubscribe } from "./hooks";
import { AppRoutes } from "./routes";
import { EventAlarmBanner } from "./components/EventAlarmBanner";
import { useToastStore, selectToasts, selectDismissToast } from "./stores";
import { NotificationBanner } from "./components/NotificationBanner";
import { AppSetupProvider } from "./components/AppSetupProvider";

export function App() {
  useStompEvents();
  useAutoPushSubscribe();
  const toasts = useToastStore(selectToasts);
  const dismissToast = useToastStore(selectDismissToast);

  return (
    // 설치·알림 안내 상태를 라우트 안팎이 같이 본다 — 배너는 여기 최상단에, 다시 띄우는
    // `알림 설정` 은 헤더의 계정 메뉴(라우트 안쪽)에 있다.
    <AppSetupProvider>
      <AppRoutes />
      <EventAlarmBanner />
      <NotificationBanner />
      <Toaster toasts={toasts} onDismiss={dismissToast} position="bottom-right" />
    </AppSetupProvider>
  );
}
